<template>
  <div class="sidebar">
    <el-menu
      :default-active="child"
      class="el-menu-vertical-demo"
      :text-color="'#77788A'"
      :active-text-color="'#0074C1'"
      @select="handleSelect"
      @open="hanldeOpen"
    >
      <template v-for="item in navPath">
        <template v-if="item[child]">
          <el-submenu :key="item.id" :index="item.id">
            <template slot="title">
              <svg-icon v-if="item.icon" :icon-class="item.icon" style="width: 20px;height: 20px;" />
              <span class="supOffice" :class="{'activeNav': activeId === item.id}">{{ item[title] }}</span>
            </template>
            <template v-for="subItem in item[child]">
              <el-submenu v-if="subItem[child]" :key="subItem.id" :index="subItem.id">
                <template slot="title">
                  <svg-icon v-if="subItem.icon" :icon-class="subItem.icon" style="width: 20px;height: 20px;" />
                  <span class="subOffice" :class="{'activeNav': activeId === item.id}">{{ subItem[title] }}</span>
                </template>
                <el-menu-item
                  v-for="threeItem in subItem[child]"
                  :key="threeItem.id"
                  :index="threeItem.id"
                >
                  <template slot="title">
                    <svg-icon v-if="subItem.icon" :icon-class="subItem.icon" style="width: 20px;height: 20px;" />
                    <span class="thrOffice" :class="{'activeNav': activeId === item.id}">{{ threeItem[title] }}</span>
                  </template>
                </el-menu-item>
              </el-submenu>
              <el-menu-item
                v-else
                :key="subItem.id"
                :index="subItem.id"
              >
                <template slot="title">
                  <svg-icon v-if="item.icon" :icon-class="subItem.icon" style="width: 20px;height: 20px;" />
                  <span class="subOffice" :class="{'activeNav': activeId === item.id}">{{ subItem[title] }}</span>
                </template>
              </el-menu-item>
            </template>
          </el-submenu>
        </template>
        <template v-else>
          <el-menu-item :key="item.id" :index="item.id">
            <template slot="title">
              <svg-icon v-if="item.icon" :icon-class="item.icon" style="width: 20px;height: 20px;" />
              <span class="supOffice" :class="{'activeNav': activeId === item.id}">{{ item[title] }}</span>
            </template>
          </el-menu-item>
        </template>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  props: {
    title: {
      type: String,
      default: 'title'
    },
    child: {
      type: String,
      default: 'subs'
    },
    navPath: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      // navPath: navList,
      defaultActive: '2-1',
      activeId: 0
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      if (keyPath.length >= 2) {
        this.activeId = keyPath[keyPath.length - 1]
        this.$emit('subMenu', keyPath)
      }
    },
    hanldeOpen(key, keyPath) {
      // if (keyPath.length >= 2) {
      //   this.$emit('subMenu', keyPath)
      // }
    }
  }
}
</script>

<style lang="less" scoped>
  .sidebar{
    width: 280px;
    padding: 28px 34px;
    border: 1px solid #EDEDEF;
    background-color: #fff;
    user-select: none;
  }
  /deep/ .el-menu{
    border: none;
    .el-submenu__title{
      height: 40px;
      padding: 0!important;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .el-menu-item{
      height: 40px;
      padding: 0!important;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .el-menu-item{
      &:hover, &.is-active{
        background-color: #EDEDEF;
        border-radius: 10px;
      }
    }
    .navItem{
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 0 8px;
      border-radius: 4px;
    }
    .activeNav{
      background-color: #f8228d!important;
    }
    .supOffice{
      .navItem;
      color: #10132C;
      padding-left: 20px!important;
    }
    .subOffice{
      .navItem;
      color: #61616f;
      padding-left: 30px!important;
    }
    .thrOffice{
      .navItem;
      color: #77788A;
      padding-left: 40px!important;
    }
  }
</style>
